import React from 'react'
import { t } from '../../../i18n'
import { useCatalogue } from '../CatalogueProvider'
import { CategoryNode } from '../catalogueTypes'
import CatalogueItemForm from './CatalogueItemForm'
import { CatalogueImageAndNameInput, CategoryPicker } from './CatalogueFormInputs'
import {
  CatalogueCancelButton,
  CatalogueDeleteButton,
  CatalogueFormSection,
  CatalogueItemTypeIndicator,
  CatalogueItemTypeSwitch,
  CatalogueSubmitButton,
  itemTypeActionLabel,
  itemTypeLabel
} from './CatalogueFormControls'
import { categoryFormValues, emptyCategoryValues, rootCategoryOptions, toCategoryFormData } from './categoryFormValues'

export const NewCategoryForm = () => {
  const { state, actions } = useCatalogue()

  return (
    <CatalogueItemForm
      title={`${t('modal.new')} `}
      initialValues={emptyCategoryValues()}
      save={(values) => actions.saveCategory(toCategoryFormData(values), null, state.categoryId)}
    >
      <CatalogueItemTypeSwitch value="category" />
      <CatalogueFormSection title={t('catalogue.sections.basic_info')} accent="blue">
        <CategoryPicker name="location" label={t('category')} options={rootCategoryOptions(state.categoryOptions)} />
        <CatalogueImageAndNameInput placeholder={t('catalogue.category_name')} />
      </CatalogueFormSection>
      <CatalogueCancelButton />
      <CatalogueSubmitButton>{itemTypeActionLabel('create', 'category')}</CatalogueSubmitButton>
    </CatalogueItemForm>
  )
}

export const EditCategoryForm = ({ category }: { category: CategoryNode }) => {
  const { state, actions } = useCatalogue()

  return (
    <CatalogueItemForm
      title={`${t('modal.edit')} ${itemTypeLabel('category')}`}
      initialValues={categoryFormValues(category, state.categoryOptions)}
      save={(values) => actions.saveCategory(toCategoryFormData(values), category.id, state.categoryId)}
    >
      {category.batch_recipes ? null : <CatalogueItemTypeIndicator value="category" />}
      <CatalogueFormSection title={t('catalogue.sections.basic_info')} accent="blue">
        {category.batch_recipes ? null : (
          <CategoryPicker name="location" label={t('category')} options={rootCategoryOptions(state.categoryOptions)} />
        )}
        <CatalogueImageAndNameInput placeholder={t('catalogue.category_name')} />
      </CatalogueFormSection>
      {category.batch_recipes ? null : <CatalogueDeleteButton item={category}>{itemTypeActionLabel('delete', 'category')}</CatalogueDeleteButton>}
      <CatalogueCancelButton />
      <CatalogueSubmitButton>{t('save')}</CatalogueSubmitButton>
    </CatalogueItemForm>
  )
}
